export const MIN_STOCK = 1
export const SPECIAL_OFFER_TYPES = {
  NORMAL: 'NORMAL',
  NEW_BATTERY: 'NEW_BATTERY',
  BATTERY_90_99: 'BATTERY_90_99',
  OUTLET: 'OUTLET',
} as const

export const PUBLICATION_STATE = {
  DISABLED: 'DISABLED',
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  IN_VALIDATION: 'IN_VALIDATION',
  MISSING_PRICE_OR_COMMENT: 'MISSING_PRICE_OR_COMMENT',
}

export const LISTING_PUBLICATION_STATE_COMPUTING_INTERVAL = 600

export const STORAGE_VIEW_TYPE_NAME = 'bo_seller.listings-should-expand-listing'

export const NUMBER_OF_LISTINGS_PER_PAGE_STORAGE_KEY =
  'bo_seller.listings-number-of-listings-per-page'

export const BUYBOX_STATE = {
  SYNCED: 0,
  PENDING: 1,
}

export const REFERENCE_MARKET_STORAGE_KEY = 'bo_seller.reference-market'
